import { ToggleItemCombinedProps } from './types';

const usePresenter = (props: ToggleItemCombinedProps): ToggleItemCombinedProps => {
  return props;
};

export default usePresenter;
